<template lang="pug">
table-base.study-result-last-minute-check-table
  table-row-base.study-result-last-minute-check-table__row
    table-header-base.study-result-last-minute-check-table__row__header.align-center
      slot(name='problemNumberHeader')
    table-header-base.study-result-last-minute-check-table__row__header.align-center
      slot(name='questionNumberHeader')
    table-header-base.study-result-last-minute-check-table__row__header.align-center
      slot(name='correctAnswerHeader')
    table-header-base.study-result-last-minute-check-table__row__header.align-center
      slot(name='correctSymbolHeader')
    table-header-base.study-result-last-minute-check-table__row__header.align-center
      slot(name='previousCorrectSymbolHeader')
    table-header-base.study-result-last-minute-check-table__row__header.align-center
      slot(name='previousTwoCorrectSymbolHeader')
  table-row-base.study-result-last-minute-check-table__row(v-for='(detail, index) in studyResultLastMinuteChecks', :key='`id_${index}`')
    table-data-base.study-result-last-minute-check-table__row__cell.align-center
      .study-result-last-minute-check-table__row__cell__label(v-if='detail.isNeedCheck') {{ annotationLabel }}
      .study-result-last-minute-check-table__row__cell__text {{ detail.problemNumberText }}
    table-data-base.study-result-last-minute-check-table__row__cell.align-center {{ detail.questionNumberText }}
    table-data-base.study-result-last-minute-check-table__row__cell.align-center( v-html='detail.correctAnswer' )
    table-data-base.study-result-last-minute-check-table__row__cell.align-center {{ detail.correctSymbol }}
    table-data-base.study-result-last-minute-check-table__row__cell.align-center {{ detail.previousCorrectSymbol }}
    table-data-base.study-result-last-minute-check-table__row__cell.align-center {{ detail.previousTwoCorrectSymbol }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TableBase from '@/components/atoms/TableBase.vue'
import TableRowBase from '@/components/atoms/TableRowBase.vue'
import TableHeaderBase from '@/components/atoms/TableHeaderBase.vue'
import TableDataBase from '@/components/atoms/TableDataBase.vue'
import { StudyResultLastMinuteCheckType } from '@/models/studyResultDetailModel'

/**
 * テスト結果直前チェック詳細テーブル
 */
@Component({
  components: {
    TableBase,
    TableRowBase,
    TableHeaderBase,
    TableDataBase,
  },
})
export default class StudyResultLastMinuteCheckTable extends Vue {
  // テスト結果直前チェック詳細表示情報
  @Prop()
  studyResultLastMinuteChecks!: StudyResultLastMinuteCheckType[]

  // 注釈のラベル記号
  @Prop()
  annotationLabel!: string
}
</script>

<style lang="stylus" scoped>
.study-result-last-minute-check-table
  width 100%

  &__row
    &__header, &__cell
      width calc(100% / 6)
      border 1px solid var(--color-study-list-table__border)

    &__header
      padding 5px
      background-color var(--color-study-list-head__background)
      color var(--color-study-list-head__text)

    &__cell
      position relative
      padding 10px

      &__label
        position absolute
        left 10px
        color var(--color-study-list-annotation__text)
</style>
